import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_ALL_STAFF = "fetchAllStaff";
export const FETCH_STAFF = "fetchStaff";
export const SAVE_STAFF = "saveStaff";
export const UPDATE_STAFF = "updateStaff";
export const DELETE_STAFF = "deleteStaff";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingCustomer";
export const SET_CUSTOMERS = "setCustomers";

const state = {
  errors: [],
  staff: [],
  isLoadingStaff: false
};

const getters = {
  isLoadingStaff() {
    return state.isLoadingStaff;
  },
  getStaff() {
    return state.staff;
  }
};

const actions = {
  [FETCH_ALL_STAFF](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("staff" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_STAFF](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("staff", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_STAFF](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("staff", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_STAFF](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("staff", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_STAFF](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("staff", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingStaff = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingStaff = value;
  },
  [SET_CUSTOMERS](state, data) {
    state.isLoadingStaff = false;
    state.staff = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
